module.exports = __webpack_public_path__ + "img/text-img.4351ab4b.svg";